import { render, staticRenderFns } from "./team-member-home.vue?vue&type=template&id=5c8757d2&scoped=true&"
import script from "./team-member-home.vue?vue&type=script&lang=js&"
export * from "./team-member-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8757d2",
  null
  
)

export default component.exports